import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import { canonical, collectionPageSchema } from "@/utils/seo";
import SectionSkeleton from "@/components/base/SectionSkeleton";
import { getAllTags } from "@/api/content";
import type { TagInfo } from "@/api/content";

export default function TagsPage({ initialData }: { initialData?: TagInfo[] }) {
  const [tags, setTags] = useState<TagInfo[]>(initialData || []);
  const [loading, setLoading] = useState(!initialData || initialData.length === 0);

  useEffect(() => {
    getAllTags().then((data) => {
      setTags(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <SectionSkeleton type="spinner" />;
  }

  return (
    <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <SEO
          meta={{
            title: "標籤專區｜美好時光指南",
            description: "瀏覽美好時光指南的所有標籤，找到你感興趣的文章與探店店家。",
            canonical: canonical("/tags"),
            keywords: ["標籤專區", "美業標籤", "文章標籤", "探店標籤", "美好時光指南"],
            structuredData: collectionPageSchema("標籤專區｜美好時光指南", "瀏覽美好時光指南的所有標籤。", "/tags"),
          }}
        />

        <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
          標籤專區
        </h1>
        <p className="text-slate-500 mb-10 max-w-2xl">
          從按摩到潛水、從台北到小琉球，用標籤快速找到你感興趣的內容
        </p>

        <div className="flex flex-wrap gap-3">
          {tags.map((tag) => {
            const total = tag.postCount + tag.storeCount;
            const sizeClass =
              total >= 5
                ? "px-5 py-2.5 text-base"
                : total >= 3
                  ? "px-4 py-2 text-sm"
                  : "px-3 py-1.5 text-sm";
            return (
              <a
                key={tag.slug}
                href={`/tags/${tag.slug}`}
                className={`inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-primary/30 hover:text-primary rounded-full text-slate-600 transition-all ${sizeClass}`}
              >
                <span className="font-medium">#{tag.name}</span>
                <span className="text-slate-400 text-xs">
                  {tag.postCount > 0 && `${tag.postCount} 篇`}
                  {tag.postCount > 0 && tag.storeCount > 0 && " · "}
                  {tag.storeCount > 0 && `${tag.storeCount} 家`}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}